import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import ReelsServices from './reels_services';

export const CreateReels = createAsyncThunk(
  'reels/create_reels',
  async (requestData, thunkAPI) => {
    try {
      const delivered = await ReelsServices.CreateReels(requestData);

      return delivered;
    } catch (e) {
      toast(e.message);
      return thunkAPI.rejectWithValue(e);
    }
  }
);

export const UploadReelsImage = createAsyncThunk(
  'reels/reels_image',
  async (requestData, thunkAPI) => {
    try {
      const delivered = await ReelsServices.uploadReelsImage(requestData);

      return delivered;
    } catch (e) {
      toast(e.message);
      console.log('Error', e);
      return thunkAPI.rejectWithValue(e);
    }
  }
);

export const UploadReelsIcon = createAsyncThunk(
  'reels/reels_icon',
  async (requestData, thunkAPI) => {
    try {
      const delivered = await ReelsServices.uploadReelsIcon(requestData);

      return delivered;
    } catch (e) {
      toast(e.message);
      console.log('Error', e);
      return thunkAPI.rejectWithValue(e);
    }
  }
);

export const GetAllReels = createAsyncThunk(
  'reels/get_all_reels',
  async (payload, thunkAPI) => {
    try {
      let response = await ReelsServices.getAllReels(payload);

      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const GetAllMajorReels = createAsyncThunk(
  'reels/get_all_major_reels',
  async (_, thunkAPI) => {
    try {
      let response = await ReelsServices.getAllMajorReels();

      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const DeleteReels = createAsyncThunk(
  'reels/delete_reels',
  async (payload, thunkAPI) => {
    try {
      let response = await ReelsServices.DeleteReels(payload);

      return response;
    } catch (error) {
      toast(error.message);
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const GetSingleReelsDetails = createAsyncThunk(
  'reels/get_single_reels',
  async (payload, thunkAPI) => {
    try {
      let response = await ReelsServices.getSingleReelsDetails(payload);

      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const EditReelsDetail = createAsyncThunk(
  'reels/edit_reels',
  async (requestData, thunkAPI) => {
    try {
      const delivered = await ReelsServices.EditReels(requestData);

      return delivered;
    } catch (e) {
      toast(e.message);
      return thunkAPI.rejectWithValue(e);
    }
  }
);

export const SearchForReelsByTitle = createAsyncThunk(
  'reels/searchForReelssByTitle',
  async (payload, thunkAPI) => {
    try {
      const delivered = await ReelsServices.SearchForReelsByTitle(payload);

      return delivered;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);
